(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ah-contact-preferences"] && !Shopify.designMode) return;
  try {
    function initializeContactPreferences(scope) {
    scope.querySelectorAll('[data-contact-preferences]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const phone = root.querySelector('input[type="tel"]');
      const hint = root.querySelector('[data-phone-hint]');
      const update = () => {
        const method = root.querySelector('input[type="radio"]:checked');
        phone.required = Boolean(method && method.value !== 'email');
        hint.textContent = phone.required ? hint.dataset.required : hint.dataset.optional;
      };
      root.addEventListener('change', update);
      update();
    });
  }
  initializeContactPreferences(document);
  document.addEventListener('shopify:section:load', (event) => initializeContactPreferences(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ah-cart-routine')) return;
  let adding = false;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  class AhCartRoutine extends HTMLElement {
    connectedCallback() {
      if (this.dataset.context === 'cart-drawer') {
        const count = this.closest('cart-drawer')?.querySelector('.ah-head__count');
        if (count) count.textContent = this.dataset.countLabel;
      }
      this.addEventListener('submit', event => this.add(event));
      if (this.dataset.context !== 'cart-page') return;
      const items = document.querySelector('cart-items');
      if (!items) return;
      this.signature = items.textContent;
      this.observer = new MutationObserver(() => {
        const signature = items.textContent;
        if (signature === this.signature) return;
        this.signature = signature;
        if (adding) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 200);
      });
      this.observer.observe(items, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      clearTimeout(this.timer);
    }
    async refresh() {
      this.abort?.abort();
      this.abort = new AbortController();
      const url = new URL(location.href);
      url.searchParams.set('sections', this.dataset.section);
      try {
        const response = await fetch(url, { signal: this.abort.signal });
        if (!response.ok) throw new Error('refresh');
        const sections = await response.json();
        const fresh = parse(sections[this.dataset.section]).querySelector('ah-cart-routine[data-context="cart-page"]');
        if (fresh && this.isConnected) this.replaceWith(fresh);
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
    async add(event) {
      const form = event.target.closest('.ah-routine__form');
      if (!form) return;
      event.preventDefault();
      if (adding) return;
      const host = this.closest('cart-drawer') || document.querySelector('cart-items');
      if (!host?.getSectionsToRender) return;
      const definitions = host.getSectionsToRender();
      const names = [...new Set([...definitions.map(item => item.section), this.dataset.section])];
      const context = this.dataset.context;
      const sectionId = this.dataset.section;
      const errorText = this.dataset.error;
      const status = this.querySelector('[role="status"]');
      const controls = [...document.querySelectorAll('.ah-routine__form button')];
      const root = window.Shopify.routes.root;
      const apply = sections => {
        const replacements = definitions.map(item => {
          const source = sections[item.section];
          const fresh = source && parse(source).querySelector(item.selector);
          const current = document.querySelector(item.selector) || document.querySelector(item.id);
          if (!fresh || !current) throw new Error('sections');
          return { current, fresh };
        });
        const routine = parse(sections[sectionId] || '').querySelector(`ah-cart-routine[data-context="${context}"]`);
        if (!routine) throw new Error('routine');
        replacements.forEach(({ current, fresh }) => { current.innerHTML = fresh.innerHTML; });
        if (context === 'cart-page' && this.isConnected) this.replaceWith(routine);
        if (typeof handleCartInputNames === 'function') handleCartInputNames();
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      };
      const reconcile = async () => {
        const url = new URL(location.href);
        url.searchParams.set('sections', names.join(','));
        const response = await fetch(url);
        if (!response.ok) throw new Error('reconcile');
        apply(await response.json());
      };
      let confirmed = false;
      adding = true;
      controls.forEach(button => { button.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const data = new FormData(form);
        data.set('sections', names.join(','));
        data.set('sections_url', location.pathname);
        const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status || result.errors) throw new Error('add');
        confirmed = true;
        try { apply(result.sections); } catch { await reconcile(); }
        const parent = document.querySelector(context === 'cart-drawer' ? 'cart-drawer' : 'main');
        (parent?.querySelector('.ah-routine__form button') || parent?.querySelector('[name="checkout"]'))?.focus({ preventScroll: true });
      } catch {
        let reconciled = false;
        try { await reconcile(); reconciled = true; } catch {}
        const current = document.querySelector(`ah-cart-routine[data-context="${context}"]`);
        if (current && (!confirmed || !reconciled)) {
          current.hidden = false;
          current.querySelector('[role="status"]').textContent = errorText;
        }
        if (!reconciled) controls.forEach(button => { button.dataset.uncertain = 'true'; });
      } finally {
        adding = false;
        this.removeAttribute('aria-busy');
        controls.forEach(button => { if (button.isConnected) button.disabled = button.dataset.uncertain === 'true'; });
      }
    }
  }
  customElements.define('ah-cart-routine', AhCartRoutine);
})();
  } catch(e) { console.error(e); }
})();

})();
